import { CheckoutContext } from "contexts/Checkout";
import { SplashPage } from "contexts/Subscription";
import { useContext } from "react";
import { Map } from "schemas/functions";

import PlanDetailsForInstagramOnboarding from "./PlanDetailsForInstagramOnboarding";
import PlanDetailsOOO from "./PlanDetailsOOO";
import PlanDetailsProBundle from "./PlanDetailsProBundle";
import PlanDetailsSettings from "./PlanDetailsSettings";
import PlanDetailsVaBundled from "./PlanDetailsVaBundled";

interface Props {
  details?: Map;
  handleBack: () => void;
  noBackButton?: boolean;
}

const PlanDetails = ({ details, handleBack, noBackButton = false }: Props) => {
  const { splashPageSource } = useContext(CheckoutContext);

  if (splashPageSource === SplashPage.instagram) {
    return <PlanDetailsForInstagramOnboarding handleBack={handleBack} />;
  } else if (splashPageSource === SplashPage.ooo) {
    return <PlanDetailsOOO />;
  } else if (splashPageSource === SplashPage.pro_bundle) {
    return <PlanDetailsProBundle />;
  } else if (splashPageSource === SplashPage.va_bundled) {
    return <PlanDetailsVaBundled />;
  } else {
    return (
      <PlanDetailsSettings
        displayName={details?.display_name}
        handleBack={handleBack}
        noBackButton={noBackButton}
      />
    );
  }
};

export default PlanDetails;
